import React from 'react';

export const Skeleton = (): React.JSX.Element => {
	return <>Loading the sandbox page...</>;
};
